import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  Link,
  BlockStack,
  InlineGrid,
  Popover,
  ActionList,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import { PlusIcon, AttachmentIcon } from "@shopify/polaris-icons";

const BulkOrderTransfer = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 100;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "Supplier Name", value: "supplier_name" },
            { label: "Client ID", value: "client_id" },
            { label: "Order Number", value: "order_number" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (id) => {
    navigate(`/admin/bulk-order-transfer/tasks/${id}`);
  };
  const switchStatusText = (status) => {
    switch (status) {
      case "registered_allocation":
        return "Registered Allocation";
      case "in_progress":
        return "In Progress";
      case "closed":
        return "Closed";
      case "completed":
        return "Completed";
      case "closed":
        return "Closeled";
      default:
        return "";
    }
  };
  const switchStatusColor = (status) => {
    switch (status) {
      case "registered_allocation":
        return "attention";
      case "in_progress":
        return "";
      case "completed":
        return "success";
      case "closed":
        return "critical";
      default:
        return "";
    }
  };

  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);

  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `/bulk-order-transfer?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "order_number" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: response.data.data.map((item, index) => [
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.shipment_number !== null ? (
              <Link monochrome>{item.shipment_number}</Link>
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.address ? (
              <EllipsisText text={item?.address} length={30} />
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.status ? (
              <Badge tone={switchStatusColor(item?.status)}>
                {switchStatusText(item?.status)}
              </Badge>
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.driver
              ? `${item?.driver?.first_name ? item?.driver?.first_name : ""} ${
                  item?.driver?.last_name ? item?.driver?.last_name : ""
                }`
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.delivery_sequence ? item?.delivery_sequence : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.coordinate_status ? item?.coordinate_status : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.notes ? (
              <EllipsisText text={item?.notes} length={30} />
            ) : (
              "-"
            )}
          </div>,

          <div
            className="clickableDiv"
            onClick={() => window.open(item?.attachment, "_blank")}
          >
            {item?.attachment ? <Icon source={AttachmentIcon}></Icon> : ""}
          </div>,

          <ButtonGroup>
            {/* <Popover
              active={popoverActive}
              activator={activator}
              autofocusTarget="first-node"
              onClose={togglePopoverActive}
            >
              <ActionList
                actionRole="menuitem"
                items={[{ content: "Import" }, { content: "Export" }]}
              />
            </Popover> */}
            <Button
              variant="primary"
              tone="critical"
              onClick={() => {
                refId.current = item.id;
                setActiveClose(true);
              }}
              disabled={item.status === "closed"}
            >
              Close
            </Button>
            <Button onClick={() => handleEdit(item.id)}>Edit</Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !response.data.data.length ? true : false,
        tableTotalPages: response.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }
  const handleClickRow = (id) => {
    window.open(`/admin/bulk-order-transfer/${id}`, "_blank");
  };
  const handleAddTask = () => {
    navigate("/admin/bulk-order-transfer/tasks/new");
  };
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This task has been successfully closed"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeClose, setActiveClose] = useState(false);
  const handleChangeModalClose = useCallback((activeClose) => {
    setActiveClose(!activeClose);
    setIsSaving(false);
  }, []);
  const handleYesClose = () => {
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", "closed");
    setIsSaving(true);
    axios
      .post(`/bulk-order-transfer/${refId.current}`, form_data)
      .then((result) => {
        setToastContent("This task has been successfully closed");
        toggleActive();
        setIsSaving(false);
        setActiveClose(!activeClose);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title="Bulk Order Transfer"
      primaryAction={
        <Button variant="primary" onClick={handleAddTask} icon={PlusIcon}>
          Add Task
        </Button>
      }
      fullWidth
    >
      <Card padding="0">
        {loadingMarkup}

        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Shipment
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Address
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Status
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Time
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Assigned Driver
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Delivery Sequence
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Coordinate Status
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Notes
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Attachment
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}
        <Modal
          open={activeClose}
          onClose={handleChangeModalClose}
          title="Close Task"
          primaryAction={{
            content: "Yes",
            onAction: handleYesClose,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalClose,
            },
          ]}
        >
          <Modal.Section>
            <Text>Are you sure you want to close this task?</Text>
          </Modal.Section>
        </Modal>
        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default BulkOrderTransfer;
